require('./bootstrap.js');

let swiper = require('./modules/swiper').default;
let scroll = require('./modules/scroll').default;
let cashback = require('./modules/cashback').default;
let messengerLicenseAgree = require('./modules/messengerLicenseAgree').default;
let debounce = require('lodash.debounce');

const Form = require('./modules/form');
const Vkontakte = require('./modules/vk');
const Homepage = require('./modules/homepage');
const Favorite = require('./modules/favorite');

window.$helpers = {
    processDostavkaClick(event, isPaid, phone) {
        if (isPaid === false) {
            event.preventDefault()

            let msg = 'К сожалению, заказ онлайн мы сейчас принять не можем. Чтобы заказать доставку, позвоните в заведение'

            if (phone) {
                msg += ' по номеру<br>' + phone
            }

            swal.fire('', msg)
        }
    },
    processToggleDropdown(container = document) { // обработка выпадающего блока
        container.querySelectorAll('.dropdown > .gbi-toggle').forEach(toggler => {
            toggler.addEventListener('click', event => {
                event.stopPropagation()

                let dropdown = toggler.nextElementSibling,
                    toggle = () => {
                        toggler.classList.toggle('gbi-toggle')
                        toggler.classList.toggle('gbi-toggle-invert')

                        return dropdown.classList.toggle('d-none')
                    }

                if (! toggle()) {
                    dropdown.addEventListener('click', event => event.stopPropagation(), { once: true })
                    document.addEventListener('click', () => {
                        if (! dropdown.classList.contains('d-none')) {
                            toggle()
                        }
                    }, { once: true })
                }
            })
        })
    },

    likeDislikeOpinion(target) { //лайк/дизлайк на отзыве
        $.post(target.dataset.url, json => {
            if (json.ret) {
                target.insertAdjacentHTML('afterend', json.html)

                target.remove()
            } else {
                swal.fire('Ошибка :(', json.msg, 'error')
            }
        })

        return false
    },

    updateSwiper(container) {
        container.querySelectorAll('.swiper').forEach(el => {
            if (el.swiper) {
                el.swiper.update();
            }
        });
    },

    getRandomInt(min, max) {
        min = Math.ceil(min * 1000);
        max = Math.floor(max * 1000);

        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    initTooltips(container = document) {
        $('[data-tooltip-content],[title][title!=""]:not([data-fancybox]),.bar__swiper-rating,.place__rating', container).tooltipster({
            delay: 100,
            delayTouch: 0,
            debug: $app.isDebug,
            contentAsHTML: true,
            contentCloning: true,
            animationDuration: 250,
            theme: 'tooltipster-punk',
            functionInit(instance, helper) {
                let $origin = $(helper.origin),
                    dataOptions = $origin.data('tooltipster');

                if (dataOptions) {
                    $.each(dataOptions, (name, option) => instance.option(name, option));
                }

                if ($origin.hasClass('place__rating') || $origin.hasClass('bar__swiper-rating')) {
                    instance.option('interactive', true);
                    instance.option('functionBefore', (instance, helper) => {
                        if ($origin.data('loaded') !== true) {
                            $.get($app.urlPrefix + '/bar/opinion/sumLikeDislike?barId=' + $origin.data('bar-id'), data => {
                                instance.content(data['list']);
                                $origin.data('loaded', true);
                                instance.open();
                                $app.runEvent('hover', 'rating-from-' + $origin.data('event'));
                            });
                        }
                    });
                }
            }
        });
    },

    initFoodMenu(container = document) {
        let items = container.querySelectorAll('.tree--foodmenu li'),
            searches = container.querySelectorAll('.foodmenu-search'),
            divNotFound = items[0]?.parentNode.parentNode.nextElementSibling,
            init = (firstTime = true) => {
                items.forEach(li => {
                    li.classList.remove('d-none')
                    li.querySelectorAll('.searchable').forEach(s => s.innerHTML = s.textContent)

                    let expand = li.querySelector('.gbi-toggle')

                    if (expand) {
                        expand.classList.remove('expanded')

                        let children = li.lastElementChild

                        children.classList.add('d-none')

                        if (firstTime) {
                            expand.parentNode.addEventListener('click', event => {
                                event.preventDefault()

                                children.classList.toggle('d-none')
                                expand.classList.toggle('expanded')
                            })
                        }
                    }
                })
            }

        init()

        searches.forEach(search => {
            search.addEventListener('keyup', debounce(() => {
                init(false)

                divNotFound.classList.add('d-none')

                if (search.value.length < 2) return

                let notFound = true,
                    regexp = new RegExp(`(${search.value})`, 'gi')

                items.forEach(li => {
                    let found

                    li.querySelectorAll('.searchable').forEach(s => {
                        s.innerHTML = s.textContent

                        if (regexp.test(s.textContent)) {
                            found = true

                            s.innerHTML = s.innerHTML.replace(regexp, `<mark>$1</mark>`)
                        }
                    })

                    if (found) {
                        notFound = false

                        let ul = li.parentNode

                        while (ul.nodeName === 'UL') {
                            ul.classList.remove('d-none')
                            ul.parentNode.querySelector('.gbi-toggle').classList.add('expanded')

                            ul = ul.parentNode.parentNode
                        }
                    } else { // если не найдено совпадений, то скрываем только в том случае, если это не категория
                        let parent = li.parentNode.parentNode.querySelector(':scope > a mark')

                        if (parent === null || parent.length === 0) {
                            li.classList.add('d-none')
                        }
                    }
                })

                divNotFound.classList.toggle('d-none', ! notFound)
            }, 400))
        })
    },

    // сокращает номера телефонов и показывает по клику
    cutPhoneForClick(container = document, len = 11, prevent = true) {
        return $(container).find('.roistat-phone:not(.no-cut-phone), .roistat-phone-tel:not(.no-cut-phone), .just-phone:not(.no-cut-phone)').each((index, el) => {
            let elem = $(el)

            if (elem.html().indexOf('показать') >= 0) {
                return
            }

            let clone = elem.clone(),
                short = elem.text().trim().slice(0, len),
                newHtml = elem.html().replace(elem.text().trim(), '') + short + `... &ndash; <span class="${elem.data('classOfColor') || 'color-grey'}">показать</span>`

            clone.on('click', event => {
                if (prevent) {
                    event.preventDefault()
                    clone.replaceWith(elem)
                }
            }).html(newHtml).insertBefore(elem)

            elem.detach()
        }).end()
    },

    // схлопываем быстрые фильтры-плитки в одну строку и показываем кнопку раскрытия/скрытия
    processQuickLinks(selector = '.filter-quick-links:not(.filter-quick-links--processed)') {
        document.querySelectorAll(selector).forEach(wrapper => {
            wrapper.querySelectorAll('.tag').forEach(tag => {
                tag.addEventListener('click', () => {
                    $app.runEvent('плитка', { [wrapper.dataset.event]: tag.textContent.trim() })
                })
            })

            if (wrapper.clientHeight > 60) {
                wrapper.classList.add('filter-quick-links--collapsed', 'filter-quick-links--processed')

                let btn = wrapper.querySelector('.filter-quick-links__toggle')

                if (btn) {
                    btn.classList.remove('d-none')

                    btn.addEventListener('click', ({ currentTarget }) => {
                        let tumbler = wrapper.classList.toggle('filter-quick-links--collapsed')

                        $app.runEvent('плитка', {
                            [wrapper.dataset.event]: btn.textContent.trim()
                        })

                        currentTarget.firstElementChild.innerText = tumbler ? 'Раскрыть' : 'Скрыть'
                    })
                }
            }
        })
    },

    initExpandableText(container = document) { // схлопывание текста до нужной высоты
        let triggerEvent = function(block) {
            $app.runEvent('click', { 'раскрытие текста': { [block.dataset.eventKey] : block.dataset.eventValue } })
        }

        container.querySelectorAll('.text-expandable').forEach(block => {
            if (block.classList.contains('text-expandable--gradient')) {
                triggerEvent(block)
            } else if (block.clientHeight > block.dataset.height) {
                block.style.height = block.dataset.height + 'px'

                let tumbler = block.querySelector('i')

                tumbler.classList.remove('d-none')
                tumbler.style.lineHeight = block.dataset.height + 'px'

                block.addEventListener('click', event => {
                    event.preventDefault()

                    triggerEvent(block)

                    block.dataset.expanded = '1'
                    block.style.height = 'auto'

                    tumbler.remove()
                }, { once: true })
            }
        })
    },

    makePopupMap(afterShow) {
        let container = $('<section class="fancybox-map-wrapper"/>')[0];

        $.fancybox.open(container, {
            afterShow(fancy) {
                new YandexMap(container, $app.cityCoords, $app.ymapApiKey).then(Map => afterShow(Map, fancy));
            },
            mobile: {
                smallBtn: 'auto',
                baseClass: 'fancybox-container--mobile-map'
            },
            smallBtn: false,
            buttons: ['close']
        });
    },

    scrollToElementAndThen(element, callback) {
        let timer

        const eventListener = () => {
            clearTimeout(timer)

            timer = setTimeout(() => {
                window.removeEventListener('scroll', eventListener)

                callback()
            }, 100)
        }

        window.addEventListener('scroll', eventListener)

        element.scrollIntoView({ behavior: 'smooth' })

        eventListener()
    }
};

window.$app = new Vue({
    data: JSON.parse(document.querySelector('meta[name="appData"]').content),

    methods: {
        runEvent: require('./modules/metrikaEvent'),

        initAuthAndReg: require('./modules/auth-and-reg'),

        scrollTo(target, offset = 0, duration = 500) {
            if ($(target).length) {
                return $('html,body').stop().animate({
                    scrollTop: $(target).offset().top - offset
                }, duration);
            }
        },

        maskPhone(container = document) {
            let phone = $('input[name*=phone]', container).mask('+0#')

            phone.on('paste', e => {
                if ($app.isModerator) {
                    e.target.value = '+7' + e.originalEvent.clipboardData.getData('text/plain').replace(/^[78+]+/, '')

                    phone.trigger('input')

                    return false
                }
            }).on('input', event => {
                if (event.target.value === '') {
                    event.target.value = '+'
                }
            }).on('focus', event => {
                if (event.target.value === '') {
                    event.target.value = '+7'
                }
            }).on('blur', event => {
                if (event.target.value === '+7') {
                    event.target.value = ''
                }
            })
        },

        isEmail(str) {
            return /^[a-z0-9_.-]+@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i.test(str);
        },

        msgr2Click(link) {
            this.runEvent(link.dataset.event, link.dataset.eventParam);
        },

        disableUserAgreement(btn) {
            $.get('/page/index/disableUserAgreement', () => {
                btn.parentNode.classList.remove('popup--visible')
            })
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    window.$app.form = new Form;

    window.copyToClipboard = require('copy-to-clipboard');

    window.$filter = require('./modules/filter').default;

    let favoriteLink = document.querySelector('.header__favorite');

    if (favoriteLink) {
        window.$app.Favorite = new Favorite(favoriteLink);
    }

    if (document.getElementById('bar')) {
        window.$bar = require('./modules/bar').default;
    }

    if (document.getElementById('bar-list-wrap')) {
        window.$listing = require('./modules/listing')();
    }

    if (!$app.isDebug) {
        new Vkontakte;
    }

    if (['/', '/spb'].indexOf(location.pathname) >= 0) {
        new Homepage;
    }

    if (location.pathname.indexOf('/metro') >= 0) {
        document.querySelectorAll('.navigation-metro > ul > li > a').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                $(event.target).next('ul').slideToggle(200, () => {
                    $(event.target).parent().siblings().find('ul').slideUp(200);
                });
            });
        });
    }

    $('body').on('click', '.fancybox3[data-type=ajax]:not([data-fancybox])', event => {
        if (event.currentTarget.dataset.event) {
            $app.runEvent('click', event.currentTarget.dataset.event);
        }

        $.fancybox.open(event.currentTarget);

        return false;
    });

    // if (!$app.isModerator) {
    //     let blagoPanels = document.querySelectorAll('.blago-under-bar-listing-preview');
    //
    //     if (blagoPanels.length) {
    //         $.get('/blago/data', response => {
    //             blagoPanels.forEach(panel => {
    //                 let barId = panel.parentNode.parentNode.parentNode.dataset.id;
    //
    //                 //скрываем плашку под фоткой о благо в листинге заведений если не сотрудничаем
    //                 if (response.participants.indexOf(barId) < 0) {
    //                     panel.classList.add('d-none');
    //                 }
    //             });
    //
    //             //подгрузка инфы скока собрано в баннер благо
    //             document.querySelectorAll('.blago-banner-stat').forEach(stat => stat.textContent = response.durationText);
    //         });
    //     }
    // }

    if (window.Ya) {
        Ya.share2('ya-share2', {
            hooks: {
                onshare(name) {
                    $app.runEvent('click', {yaShare: name});
                }
            }
        });
    }

    let jumpLink = document.getElementById('jump-top')

    if (jumpLink) {
        window.onscroll = () => jumpLink.classList.toggle('d-none', window.scrollY <= 1500)
    }

    $helpers.initTooltips(document.querySelector('.header__content'));

    if ($app.isMobile && window.$listing || ['/help', '/'].indexOf(location.pathname) >= 0) {
        window.teletypeButton = 'invisible';
    }

    document.addEventListener('teletype.ready', () => {
        document.addEventListener('teletype.opened', () => $app.runEvent('teletype', 'opened'));
        document.addEventListener('teletype.dialogStarted', () => $app.runEvent('teletype', 'dialogStarted'));

        $('body').on('click', 'a[href="#showchat"]', event => {
            event.preventDefault();

            window._teletypeWidget.setMessage(event.target.dataset.message || '');
            window._teletypeWidget.show();
        });

        if (location.hash === '#showchat') {
            window._teletypeWidget.show()
        }
    });

    document.querySelectorAll('.vueable').forEach(el => new Vue({ el }));

    if (['/kuda-pojti', '/help'].some(el => location.pathname.endsWith(el))) {
        swiper('.swiper', {
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 }
            }
        })
    }

    if (location.pathname.endsWith('/seti')) {
        let dataset = document.getElementById('seti-dataset'),
            search = dataset.previousElementSibling;

        search.addEventListener('change', event => {
            let selected = dataset.options.namedItem(event.target.value);

            if (selected) {
                location.href = $app.urlPrefix + '/seti/' + selected.dataset.id;
            }
        });
    }

    if (location.pathname.indexOf('/blyuda') >= 0) {
        document.querySelectorAll('.tree:not(.tree--foodmenu) li').forEach(li => {
            let a = li.querySelector('a:first-child'),
                toggler = a?.querySelector('i'),
                isSelected = location.href === a.href

            if (isSelected) {
                a?.classList.add('selected')
                toggler?.classList.add('expanded')

                let parentLi = li.parentNode.parentNode

                while (parentLi.nodeName === 'LI') {
                    parentLi.lastElementChild.classList.remove('d-none')
                    parentLi.querySelector('a i').classList.add('expanded')
                    parentLi = parentLi.parentNode.parentNode
                }
            }

            if (toggler) {
                if (! isSelected) {
                    li.lastElementChild.classList.add('d-none')
                }

                a.addEventListener('click', event => {
                    if (event.target.isSameNode(toggler)) {
                        event.preventDefault()

                        toggler.classList.toggle('expanded')
                        li.lastElementChild.classList.toggle('d-none')

                        $filter.swiper?.updateAutoHeight()
                    }
                })
            }
        })
    }

    if (location.pathname.endsWith('/otzyvy-o-restoranah')) {
        $app.form.review()

        let container = document.getElementById('review-list')

        $helpers.initTooltips(container)

        document.getElementById('paginator').addEventListener('click', event => {
            event.preventDefault()

            $filter.startLoading()

            $.get(event.target.href, response => {
                event.target.href = response.url

                let last = container.querySelector('.review-item:last-of-type')

                response.otzyvy.forEach(item => {
                    let div = document.createElement('div')

                    div.innerHTML = item.trim()

                    $helpers.initTooltips(container.insertBefore(div.firstChild, last.nextElementSibling))
                })

                last.nextElementSibling.scrollIntoView({ behavior: 'smooth' })

                $app.form.review()

                $filter.stopLoading()
            })
        })
    }

    cashback()
    messengerLicenseAgree()

    scroll('.scrollable')

    $helpers.processQuickLinks()
    $helpers.initExpandableText()
    $helpers.processToggleDropdown()

    document.dispatchEvent(new CustomEvent('app:ready'))

    if (window.dataLayer) {
        let eridElements = []

        document.querySelectorAll('[data-erid]:not([data-erid=""])').forEach(el => {
            eridElements.push({
                id: el.dataset.erid,
                name: el.dataset.eridName
            })
        })

        if (eridElements.length) {
            window.dataLayer.push({
                'ecommerce': {
                    'promoView': {
                        'promotions': eridElements
                    }
                }
            })
        }
    }
});